export const FETCH_SYSTEM_SETTINGS_REQUEST =
  'systemSettings/FETCH_SYSTEM_SETTINGS_REQUEST'
export const FETCH_SYSTEM_SETTINGS_SUCCESS =
  'systemSettings/FETCH_SYSTEM_SETTINGS_SUCCESS'
export const FETCH_SYSTEM_SETTINGS_FAILURE =
  'systemSettings/FETCH_SYSTEM_SETTINGS_FAILURE'

export const UPDATE_SYSTEM_SETTINGS_REQUEST =
  'systemSettings/UPDATE_SYSTEM_SETTINGS_REQUEST'
export const UPDATE_SYSTEM_SETTINGS_SUCCESS =
  'systemSettings/UPDATE_SYSTEM_SETTINGS_SUCCESS'
export const UPDATE_SYSTEM_SETTINGS_FAILURE =
  'systemSettings/UPDATE_SYSTEM_SETTINGS_FAILURE'

export const UPDATE_FIELD = 'systemSettings/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'systemSettings/SET_DEFAULT_DATA'
